/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/recommendationsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Recommendations. */
export class Recommendations {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Recommendations.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Retrieves all recommendations for the current user.
   * @summary Retrieves all recommendations for for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.RecommendationsGetRecommendationsResponse>
   */
  getRecommendations(options?: coreHttp.RequestOptionsBase): Promise<Models.RecommendationsGetRecommendationsResponse>;
  /**
   * @param callback The callback
   */
  getRecommendations(callback: coreHttp.ServiceCallback<Models.Recommendation[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getRecommendations(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.Recommendation[]>): void;
  getRecommendations(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.Recommendation[]>, callback?: coreHttp.ServiceCallback<Models.Recommendation[]>): Promise<Models.RecommendationsGetRecommendationsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getRecommendationsOperationSpec,
      callback) as Promise<Models.RecommendationsGetRecommendationsResponse>;
  }

  /**
   * Dismisses the specific recommendation using the given properties.
   * @summary Dismisses the recommendation by recommendation id.
   * @param recommendationId
   * @param [options] The optional parameters
   * @returns Promise<Models.RecommendationsDismissRecommendationResponse>
   */
  dismissRecommendation(recommendationId: string, options?: Models.RecommendationsDismissRecommendationOptionalParams): Promise<Models.RecommendationsDismissRecommendationResponse>;
  /**
   * @param recommendationId
   * @param callback The callback
   */
  dismissRecommendation(recommendationId: string, callback: coreHttp.ServiceCallback<Models.RecommendationState>): void;
  /**
   * @param recommendationId
   * @param options The optional parameters
   * @param callback The callback
   */
  dismissRecommendation(recommendationId: string, options: Models.RecommendationsDismissRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.RecommendationState>): void;
  dismissRecommendation(recommendationId: string, options?: Models.RecommendationsDismissRecommendationOptionalParams | coreHttp.ServiceCallback<Models.RecommendationState>, callback?: coreHttp.ServiceCallback<Models.RecommendationState>): Promise<Models.RecommendationsDismissRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        recommendationId,
        options
      },
      dismissRecommendationOperationSpec,
      callback) as Promise<Models.RecommendationsDismissRecommendationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getRecommendationsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Recommendations",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "Recommendation"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const dismissRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me/Recommendations/{recommendationId}",
  urlParameters: [
    Parameters.recommendationId2
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PatchRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.RecommendationState
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
